function parseBool(v: unknown, fallback: boolean): boolean {
  if (typeof v !== 'string') return fallback;
  const s = v.trim().toLowerCase();
  if (s === '1' || s === 'true' || s === 'yes' || s === 'on') return true;
  if (s === '0' || s === 'false' || s === 'no' || s === 'off') return false;
  return fallback;
}

/**
 * Centralized permission enforcement toggle.
 *
 * - true  => enforce RBAC normally
 * - false => bypass ALL permission checks (dev/testing)
 */
export const ENABLE_PERMISSION_CHECK = parseBool(import.meta.env.VITE_ENABLE_PERMISSION_CHECK, true);

